import { Outlet, Routes } from 'react-router-dom';
import { Route } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';

import ArrowheadLeftIcon from '../../../../icons/ArrowheadLeftIcon';
import ArrowheadRightIcon from '../../../../icons/ArrowheadRightIcon';
import CloseIcon from '../../../../icons/CloseIcon';
import routes from '../../../../pages/routes';
import { forDesktop } from '../../../../utils/media-queries';
import { leftActionsClasses, StyledButton } from './styles';
import { UseExpandCollapseToggleButton } from './vm';
import useExpandCollapseToggleButton from './vm';

interface ExpandCollapseToggleButtonProps extends UseExpandCollapseToggleButton {}

const ExpandCollapseToggleButton = ({ ...vmProps }: ExpandCollapseToggleButtonProps) => {
  const isDesktop = useMediaQuery(forDesktop);

  const { expandButtonRef, isCommentsPanelExpanded, toggleExpand, handleClose, getTranslatedAriaLabel } =
    useExpandCollapseToggleButton(vmProps);

  if (isDesktop) {
    return (
      <StyledButton
        ref={expandButtonRef}
        edge="start"
        aria-label={getTranslatedAriaLabel('desktop')}
        onClick={toggleExpand}
        size="small"
        variant="text"
        className={leftActionsClasses.button}
      >
        {isCommentsPanelExpanded ? (
          <ArrowheadRightIcon color="inherit" aria-hidden />
        ) : (
          <ArrowheadLeftIcon color="inherit" aria-hidden />
        )}
      </StyledButton>
    );
  }

  return (
    <StyledButton
      edge="start"
      aria-label={getTranslatedAriaLabel('mobile')}
      onClick={handleClose}
      size="small"
      variant="text"
      className={leftActionsClasses.button}
    >
      <CloseIcon color="inherit" aria-hidden />
    </StyledButton>
  );
};

const LeftActions = () => {
  return (
    <Routes>
      <Route path={routes.home.relativePath} element={<ExpandCollapseToggleButton type="faq" />} />
      <Route path={routes.settings.relativePath} element={<Outlet />}>
        <Route index element={<ExpandCollapseToggleButton type="faq" />} />
        <Route path={routes.refer.relativePath} element={<ExpandCollapseToggleButton type="faq" />} />
      </Route>
      <Route path={routes.university.relativePath} element={<Outlet />}>
        <Route
          path={routes.archivedCourses.relativePath}
          element={<ExpandCollapseToggleButton type="faq" />}
        />
        <Route path="*" element={<ExpandCollapseToggleButton />} />
      </Route>
      <Route path="*" element={<ExpandCollapseToggleButton />} />
    </Routes>
  );
};

export default LeftActions;
